import React, { useContext, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import { MyContext } from '../context/Context';
import { get_user_details } from '../api/api';
import { Link } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import Loader from '../Loader/Loader';
import $ from 'jquery';
import { filter } from 'jszip';

function Customer() {
    const [customerList, setCustomerList] = useState([]);
    const { loader, setLoader } = useContext(MyContext);
    const [customerDetails, setCustomerDetails] = useState([])

    useEffect(() => {
        fetch_customer_details();
    }, []);

    // Fetch customer details
    const fetch_customer_details = async () => {
        setLoader(true);
        try {
            const res = await get_user_details({ user_type: "customer" });
            if (res.status === 200) {
                setCustomerList(res.data.data);
            }
            setLoader(false);
        } catch (error) {
            console.error("User details API error:", error);
            setLoader(false);
        }
    };


    const handle_customer_detail = (id) => {

        const filter_customer = customerList?.filter((customer) => customer.id === id)
        setCustomerDetails(filter_customer[0]);
    };

    console.log(customerList)


    // data table 
    useEffect(() => {
        const tableId = '#example2';
        const table = $(tableId);

        // Destroy any existing DataTable instance before initializing a new one
        if ($.fn.DataTable.isDataTable(tableId)) {
            table.DataTable().destroy();
        }

        // Initialize DataTable with scrollX for horizontal scrolling
        table.DataTable({
            paging: true,
            lengthChange: true,
            pageLength: 10,
            lengthMenu: [5, 10, 15, 20],
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            infoFiltered: "(filtered from _MAX_ total records)",
            // buttons: ['copy', 'excel', 'pdf', 'print'],
            // dom: 'Bfrtip',
            pagingType: 'full_numbers', // Pagination with full numbers
            language: {
                paginate: {
                    first: '«',
                    last: '»',
                    next: '›',
                    previous: '‹',
                }
            },
            drawCallback: function (settings) {
                const api = this.api();
                const info = api.page.info();
                const $paginate = $(tableId + '_paginate').find('span a.paginate_button');
                const currentPage = info.page;
                const totalPages = info.pages;

                // Show only specific pages with ellipses
                $paginate.each(function (index) {
                    const pageIndex = parseInt($(this).text(), 10) - 1;
                    if (isNaN(pageIndex)) return; // Skip non-number buttons

                    if (
                        pageIndex === 0 ||
                        pageIndex === totalPages - 1 ||
                        (pageIndex >= currentPage - 1 && pageIndex <= currentPage + 1)
                    ) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                // Add ellipses if necessary
                if (currentPage > 2) {
                    $('<span className="paginate_button ellipsis">...</span>').insertAfter($paginate.eq(0));
                }
                if (currentPage < totalPages - 3) {
                    $('<span className="paginate_button ellipsis">...</span>').insertBefore($paginate.eq(totalPages - 1));
                }
            }
        });

        return () => {
            if ($.fn.DataTable.isDataTable(tableId)) {
                table.DataTable().destroy();
            }
        };
    }, [customerList]);


    return (
        <div className="wrapper">
            <Navbar />
            <Sidebar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12 d-flex flex-column flex-sm-row justify-content-between">
                                <h1 className="m-0 mr-3">Customers</h1>
                                <span className='text-sm d-flex justify-content-end mt-4 mb-4 mt-sm-0 mb-sm-0'>
                                    <Link to="/dashboard">Dashboard</Link>
                                    <span className='ml-1 mr-1'>/</span>
                                    <span>Customers</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {loader ? <Loader /> : (
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Customer List</h3>
                                        </div>
                                        <div className="card-body">

                                            <div className='table-responsive'>
                                                <table id="example2" className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>Mobile No</th>
                                                            <th>Email Id</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>


                                                    <tbody>
                                                        {
                                                            customerList && customerList.map((user, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{user.firstname || user.lastname ? user.firstname + " " + user.lastname : " - "}</td>
                                                                    <td>{user.mobile_no}</td>
                                                                    <td>{user.email ? user.email : ' - '}</td>
                                                                    <td style={{ width: "205px" }}>
                                                                        <div className="btn-group">
                                                                            <button type="button" className="btn btn-naariyal-green dropdown-toggle" data-toggle="dropdown">Action</button>
                                                                            <div className="dropdown-menu" role="menu">
                                                                                <Link
                                                                                    to="/orders"
                                                                                    className="dropdown-item text-info"
                                                                                    state={{ userId: user.id }}
                                                                                >
                                                                                    <i className="nav-icon fa-solid fa-list-check mr-2"></i>
                                                                                    Order List
                                                                                </Link>

                                                                                <div className="dropdown-divider"></div>

                                                                                <a
                                                                                    className="dropdown-item text-info"
                                                                                    data-toggle="modal"
                                                                                    data-backdrop="static"
                                                                                    data-target="#orderDetails"
                                                                                    onClick={() => {
                                                                                        handle_customer_detail(user?.id);
                                                                                    }}
                                                                                >
                                                                                    <i className="nav-icon fa-solid fa-address-card mr-2"></i>
                                                                                    Customer details
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Order details */}
                        <div className="modal fade pr-0" id="orderDetails" tabIndex={-1} role="dialog" aria-labelledby="orderDetailsModal" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <div className="modal-content">
                                    <div className="modal-header border-0">
                                        <h5>Customer Details</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="input-group">

                                            {/* <div className='w-100 mb-3 d-flex '>
                                                <div className='w-100'>
                                                    <label htmlFor="area_name">Customer name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name='customer_name'
                                                        value={customerDetails.firstname ? customerDetails.firstname + ' ' + customerDetails.lastname : '-'}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-100 mb-3 d-flex '>
                                                <div className='w-100'>
                                                    <label htmlFor="area_name">Mobile no</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name='customer_name'
                                                        value={customerDetails?.mobile_no ? customerDetails?.mobile_no : ''}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-100 mb-3 d-flex '>
                                                <div className='w-100'>
                                                    <label htmlFor="area_name">Email id</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name='customer_name'
                                                        value={customerDetails?.email ? customerDetails?.email : ''}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-100'>
                                                <label htmlFor="area_name">Address</label>
                                                <textarea
                                                    type=""
                                                    className="form-control"
                                                    name='delivery_address'
                                                    value={customerDetails?.address ? customerDetails?.addres : ''}
                                                    disabled
                                                />
                                            </div> */}
                                            <form className="container">
                                                <div className="form-group row">
                                                    <div className="col-12 mb-2">
                                                        <div className="row">
                                                            <div className="col-4 d-flex align-items-center">
                                                                <label htmlFor="area_name col-form-label" style={{ margin: '0' }}>Customer name :</label>
                                                            </div>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control border-0 bg-transparent border-outline"
                                                                    name='customer_name'
                                                                    value={customerDetails?.firstname ? customerDetails.firstname + ' ' + customerDetails.lastname : '-'}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 mb-2">
                                                        <div className="row">
                                                            <div className="col-4 d-flex align-items-center">
                                                                <label htmlFor="area_name col-form-label" style={{ margin: '0' }}>Mobile no :</label>
                                                            </div>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control border-0 bg-transparent border-outline"
                                                                    name='mobile_no'
                                                                    value={customerDetails?.mobile_no ? customerDetails?.mobile_no : '-'}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12 mb-2">
                                                        <div className="row">
                                                            <div className="col-4 d-flex align-items-center">
                                                                <label htmlFor="area_name col-form-label" style={{ margin: '0' }}>Email :</label>
                                                            </div>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control border-0 bg-transparent border-outline"
                                                                    name='email'
                                                                    value={customerDetails?.email ? customerDetails?.email : '-'}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <div className="col-12 d-flex align-items-center mb-2">
                                                                <label htmlFor="area_name col-form-label" style={{ margin: '0' }}>Addresses :</label>
                                                            </div>
                                                            {
                                                                customerDetails.addresses && customerDetails.addresses.map((address, index) =>
                                                                    <div className="col-12 border border-muted mb-3" key={index}>
                                                                        <div className="p-2 rounded" style={{ minHeight: "65px" }}>
                                                                            {address?.address_line_1 + ', ' + address?.address_line_2 + ', ' + address?.area + ', ' + address?.city + ', ' + address?.state + ' - ' + address?.pincode}

                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                    <div className="modal-footer border-0">

                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                )}
            </div>
            <Footer />
        </div>
    );
}

export default Customer;
